// Browser storage is for preferences and drafts only — never shared state.
// Every access is guarded: private windows and blocked storage just forget.

export function load<T>(key: string, fallback: T): T {
  try {
    const raw = localStorage.getItem(`gl:${key}`)
    return raw ? (JSON.parse(raw) as T) : fallback
  } catch { return fallback }
}

export function save(key: string, value: unknown): void {
  try {
    if (value === null || value === undefined || value === '') localStorage.removeItem(`gl:${key}`)
    else localStorage.setItem(`gl:${key}`, JSON.stringify(value))
  } catch { /* storage unavailable */ }
}

export function prefersReducedMotion(): boolean {
  try { return matchMedia('(prefers-reduced-motion: reduce)').matches || document.documentElement.dataset.motion === 'reduced' } catch { return false }
}
